/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Ficcao() {
  return (
    <PaginasEspecificas posicao="18" endereco="/fisica" materia="Física" />
  );
}

export default Ficcao;
